import React from 'react';

import IntegrationImage, { integrationImageById } from 'assets/img/integrations';

interface ManageAppsIntegrationImageProps extends StyleProps {
  /** @string - Integration name */
  itemIntegrationName: string;
}

export const ManageAppsIntegrationImage: React.FC<ManageAppsIntegrationImageProps> = ({
  itemIntegrationName,
}) => {
  const integrationIcon = integrationImageById(itemIntegrationName, IntegrationImage, false);

  return <>{itemIntegrationName && integrationIcon}</>;
};
